import axiosInstance from '../services/axiosInstance';

export function initQZSecurity() {
  if (!window.qz) {
    console.warn('QZ Tray not loaded yet');
    return;
  }
window.qz.security.setSignatureAlgorithm("SHA512");
  console.log('Initializing QZ security');

  // SIGNATURE HANDLER
window.qz.security.setSignaturePromise(function(toSign) {
  return function(resolve, reject) {
    axiosInstance
      .get('/api/qz/sign/', {
        params: { request: toSign },
        headers: { 'Content-Type': 'text/plain' }
      })
      .then(res => resolve(res.data.signature))
      .catch(err => reject(err));
  };
});


  // CERTIFICATE HANDLER
 window.qz.security.setCertificatePromise(function(resolve, reject) {
  axiosInstance
    .get('/api/qz/certificate/', {
      headers: { 'Content-Type': 'text/plain' }
    })
    .then(res => resolve(res.data))
    .catch(err => reject(err));
});
}
